export default [{
  name: 'troubleshootingTools',
  path: '/troubleshootingTools',
  component: () => import('./TroubleshootingTools.vue'),
  meta: {
    title: '故障处理工具'
  }
}]



// WEBPACK FOOTER //
// ./src/router/troubleshooting_tools/index.js